// --- lib/constants.js ---

export const AUCTION_TYPES = {
    FIRST_PRICE: { name: 'First-Price Sealed-Bid' },
    ENGLISH: { name: 'English Reverse (2nd Price Open)' },
    DUTCH: { name: 'Dutch Reverse (Descending Price)' },
    VICKREY: { name: 'Vickrey Reverse (2nd Price Sealed)' },
  };
  
  export const COMPETITOR_TYPES = {
    AGGRESSIVE: { name: 'Aggressive Tier 2', markup: 1.08 },
    ESTABLISHED: { name: 'Established Tier 1', markup: 1.15 },
    NEW_ENTRANT: { name: 'New Entrant (Desperate)', markup: 1.05 },
  };
  
  export const PROJECT_TYPES = {
      PV_SOLAR: "PV Solar",
      SOLAR_BESS: "Solar with BESS",
      ONSHORE_WIND: "Onshore Wind",
      OFFSHORE_WIND: "Offshore Wind",
      OTHER_CAPEX: "Other CAPEX"
  };
  
  export const COST_STRUCTURES = {
      PV_SOLAR: { panels: 60, inverters: 15, structures: 25, bos: 20, labor: 20, contingency: 10 },
      SOLAR_BESS: { panels: 55, inverters: 14, structures: 22, bess: 30, bos: 22, labor: 22, contingency: 15 },
      ONSHORE_WIND: { turbines: 90, foundations: 30, gridConnection: 25, civilWorks: 20, logistics: 15, contingency: 20 },
      OFFSHORE_WIND: { turbines: 150, foundations: 80, gridConnection: 60, installationVessel: 50, logistics: 25, contingency: 35 },
      OTHER_CAPEX: { equipment: 100, construction: 50, engineering: 20, commissioning: 15, contingency: 15 }
  };
  
  export const CURRENCIES = {
      USD: { symbol: '$', name: 'USD' },
      EUR: { symbol: '€', name: 'EUR' },
      CNY: { symbol: '¥', name: 'CNY' },
      PHP: { symbol: '₱', name: 'PHP' },
  };
  